module.exports = __webpack_public_path__ + "assets/img/江永智.bce01de1.png";